import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import BarChartWithUpwardArrow from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/BarChartWithUpwardArrow';
import CurvedArrowThroughXxo from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/CurvedArrowThroughXxo';
import DollarSignRevolvingArrows from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/DollarSignRevolvingArrows';
import PaperWithDollarSignAndBarChart from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperWithDollarSignAndBarChart';
import PottedPlantWithDollarSignCircle from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PottedPlantWithDollarSignCircle';
import TwoPapersWithDollarSign from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoPapersWithDollarSign';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';

export const ITEMS = [
  {
    id: 'variable-universal-life-insurance-cash-value',
    icon: PottedPlantWithDollarSignCircle,
    title: 'Cash value',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        VUL builds cash value over time that grows, tax deferred, that you can use for anything, anytime.<sup>1</sup> Your policy also has the potential to build even more cash value than you could with traditional permanent life insurance.
      </Typography>
    ),
  },
  {
    id: 'variable-universal-life-insurance-death-benefit',
    icon: PaperWithDollarSignAndBarChart,
    title: (<>Flexible premiums &#38; <WidowBlock>death benefit</WidowBlock></>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        With VUL, you&#39;ll have the flexibility to choose the amount of your death benefit, how much you pay in premiums, and when you pay them. As long as there is enough cash value to pay your policy&#39;s monthly fees and expenses, your coverage will generally continue.
      </Typography>
    ),
  },
  {
    id: 'variable-universal-life-insurance-flexible-adjustments',
    icon: TwoPapersWithDollarSign,
    title: 'Flexible investments',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        VUL also gives you flexibility in how your cash value is invested, allowing you to choose from multiple policy investment options managed by leading investment firms.
      </Typography>
    ),
  },
  {
    id: 'variable-universal-life-insurance-de-risk-option',
    icon: CurvedArrowThroughXxo,
    title: (<>Option to de&#45;risk over time</>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Our Strength and Stability account (SAS)<sup>2</sup> lets you move some money out of the market permanently if you want to take on less risk over time. Plus, you&#39;ll get a crediting rate that&#39;s backed by the Northwestern Mutual general account.<sup>3</sup>
      </Typography>),
  },
  {
    id: 'variable-universal-life-insurance-automatic-rebalancing',
    icon: DollarSignRevolvingArrows,
    title: 'Automatic rebalancing',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        VUL also comes with the option to use automatic rebalancing, giving you periodic, automatic adjustments that can help keep your diversified investment plan on track.
      </Typography>
    ),
  },
  {
    id: 'variable-universal-life-insurance-dollar-cost-averaging',
    icon: BarChartWithUpwardArrow,
    title: 'Dollar cost averaging',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        With this feature, money is moved from a money market account to your investment accounts at regular intervals. That way, you generally purchase more investments when the market is down and fewer when <WidowBlock>it&#39;s up.<sup>4</sup></WidowBlock>
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='variable-universal-life-insurance'
      backgroundVariant='lightB'
      headingText={<>The benefits of variable universal <WidowBlock>life policies</WidowBlock></>}
      cardDataArray={ITEMS}
    />
  );
};
